import {
  ACTION_COMMON_SET_MEDIA_REQUEST,
  ACTION_DISCOVERY_SHOW_SKIPPABLE_CONTENT,
  ACTION_DISCOVERY_SHOW_UP_NEXT,
} from '../../../common/store/store.actions';

export const updateShowUpNext = (showUpNext: boolean) => (dispatch): void => {
  dispatch({
    type: ACTION_DISCOVERY_SHOW_UP_NEXT,
    payload: showUpNext,
  });
};

export const updateShowSkippableContent = (showSkippableContent: boolean) => (dispatch): void => {
  dispatch({
    type: ACTION_DISCOVERY_SHOW_SKIPPABLE_CONTENT,
    payload: showSkippableContent,
  });
};

export const playNextVideo = () => (dispatch): void => {
  dispatch({
    type: ACTION_COMMON_SET_MEDIA_REQUEST,
    payload: { mediaRequestObject: { type: 'playNextVideo', value: '' } },
  });
};
